const projectsDict = {
    "0": {
        "title": "TCBee",
        "short": "TCBee",
        "description": "A Rust TCP flow analyzer built on eBPF that records kernel metrics at up to 5M events/s into a structured database. A companion tool visualizes and compares flow metrics like the congestion window or lost packets.",
        "icon": "/tcbee.png",
        "link": "https://github.com/uni-tue-kn/TCBee"
    },
    "1": {
        "title": "UniCorn-P4",
        "short": "UniCorn-P4",
        "description": "A generalized control plane to configure P4 switches from a UI. It also ships a Mininet testbed extension for students to learn P4.",
        "icon": "/unicorn.png",
        "link": "https://github.com/uni-tue-kn/UniCorn-P4"
    },
    "2": {
        "title": "vim-forcer",
        "short": "vim-forcer",
        "description": "Enforces vim system-wide by killing nano on open and swapping in vim in the same shell. A fun project built for an eBPF talk.",
        "icon": "/vim-forcer.svg",
        "link": "https://github.com/MoritzFlu/vim-forcer"
    },
    "3": {
        "title": "JavaScript Network Simulator",
        "short": "Network Simulator",
        "description": "A from-scratch JavaScript simulator modeling STP, ARP, IPv4, routing, DNS, TCP and HTTP. It powers the live demo on this site.",
        "link": "https://github.com/MoritzFlu/website"
    }
}

export default projectsDict;
